import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';
import cUserList from './cUserList';

class iUserList extends cUserList {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  $clp_loads = () => [ // 親を上書き
/*
    new Promise( _o_end1 => {
      global.c?.setState({
        sgcd_pageCmns?: bf.p(global.c?.state.sgcd_pageCmns?, _next =>{ // sgcd_pageCmns? の初期化
          _next.cm10_key = '';
          _next.cm10c310 = '';
        })
      }, ()=>{
        _o_end1();
      })
    }),
*/
    new Promise( _o_end1 => {
      //
      let _cnd = global.c?.$id_stgs.cLoadCnd();
      if (bf.f(global.c?.state.sgcd_schs.word)) {
        _cnd = bf.q('[cm10c310] LIKE "%{}%"'.f(global.c?.state.sgcd_schs.word));
      };
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: 'cm10', 
        n_dms: 3,
        state: 'sld_cm10ss', 
        cnd: _cnd,
        do_rfrs: {
          cm1i: _d_is => bf.q('[cm1ib11k]="{}"'.f(_d_is._KEY)),
        },
        dld_pcksss: {
          cm10c410:[
            {key: '10', pfx:'キャスト'},
            {key: '90', pfx:'店舗運営者'},
            {key: '80', pfx:'事務担当者'},
          ],
          cm10cz10:[
            {key: '0', pfx:'表示しない'},
            {key: '10', pfx:'表示する'},
          ],
        },
        ld_sortss: [
          {fld:'cm10cz10', dtn:'desc', mode:'str'}, 
          {fld:'cm1ii110', dtn:'asc', mode:'nmb'}
        ],
        o_fnc: _d_cm10s => {
          return {
/*
            pfx: '{}'.f(
              _d_cm10s.cm10c330,
            ),
*/
            pfx: '{} {}'.f(
              bf.myCM_pdd(_d_cm10s.cm1ii110, 3),
              _d_cm10s.cm10c330,
            ),
//            spf: '{}'.f(
//              _d_cm10s.cm10i110,
//            ),
            spf: '{}, {}'.f(
             _d_cm10s.cm10c410,
             _d_cm10s.cm10cz10,
            ),
          };
        }
      })
      .then(()=>{
        _o_end1();
      });
    }),
  ];

  $id_stgs = {
    cLoadCnd: () => {
      if (global.c?.state.sgcd_pageCmns?.userc410 == '80') {
        let _cnd = bf.q('[cm10b21k]="{}"'.f(
  //      global.c?.state.sgcd_pageCmns?.cm20_key,
          global.c?.state.sgcd_pageCmns?.cm20_key,
        ));
//bf.l('81:{}'.f(_cnd));
        return _cnd;
      }
      else {
        let _cnd = bf.q('[cm10b21k]="{}" AND IFNULL([cm10cz10],"10")<>"0"'.f( // 非表示を除く
  //      global.c?.state.sgcd_pageCmns?.cm20_key,
          global.c?.state.sgcd_pageCmns?.cm20_key,
        ));
//bf.l('89:{}'.f(_cnd));
        return _cnd;
      }
    },
  };

  render() {
//bf.l('82:{}'.f(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]))
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iUserDtl',
            sgc_pageMode: 'new',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: iv._get_hdrPfx('スタッフ一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            ld_iss: [
              ip.dd_rptss['スタッフ一覧CSV'],
            ],
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_cm10ss',
              nextRole: 'own3',
              nextPage: 'iUserDtl',
              nextMode: 'show',
//              pagePntKeyName: 'cm10_key', // sgcd_pageCmns? へ反映するために必要
              keyName: 'cm10_key', // sgcd_pageCmns? へ反映するために必要
              pfxName: 'cm10_pfx',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
          ],
        }}
      />
    );
  }
};

export default iUserList;
